export default {
  namespaced: true,
  state() {
    return {
      selectedProperties: [],
      variants: [],
      chosenVariant: null,
    };
  },
  getters: {
    selectedProperties: state => {
      return state.selectedProperties;
    },
    allProductVariants: state => {
      return state.variants;
    },
    chosenVariant: state => {
      return state.chosenVariant;
    },
  },
  actions: {
    setSelectedProperties: (context, variant) => {
      context.commit("setSelectedProperties", variant);
    },
    setProductVariants: (context, variants) => {
      context.commit("setProductVariants", variants);
    },
    emptySelectedProperties: context => {
      context.commit("emptySelectedProperties");
    },
    setChosenVariant: (context, variantId) => {
      context.commit("setChosenVariant", variantId);
    },
  },
  mutations: {
    setSelectedProperties: (state, property) => {
      const selectedProperties = state.selectedProperties;

      selectedProperties.forEach((stateProperty, index) => {
        if (stateProperty.key === property.key) {
          state.selectedProperties.splice(index, 1);
        }
      });

      state.selectedProperties.push(property);
    },
    setProductVariants: (state, variants) => {
      state.variants = variants;
    },
    emptySelectedProperties: state => {
      state.selectedProperties = [];
    },
    setChosenVariant: (state, variantId) => {
      state.chosenVariant = variantId;
    },
  },
};
